<div class="edit-form-container" (click)="$event.stopPropagation()">
  <div class="form-header">
    <div class="header-title-group">
      <mat-icon>edit</mat-icon>
      <span>{{ 'ORDERS.MODIFY' | translate }}</span>
    </div>
    <button mat-icon-button (click)="endUpdate()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="form-section">
    @if (orderForm) {
      <ng-container [formGroup]="orderForm">
        <div class="checkbox-card-group">
          <mat-checkbox formControlName="emailIsActive" color="primary">{{ 'ADMIN.ORDER_ACTIVE_CHECK' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="disabled" color="primary">{{ 'ADMIN.DISABLED_ORDER' | translate }}</mat-checkbox>
        </div>
      </ng-container>
    }
    
    @if (invoiceAddressForm) {
      <ng-container [formGroup]="invoiceAddressForm">
        <div class="form-section">
          <div class="section-title">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px;">receipt</mat-icon>
            <span>{{ 'settings.okto.invoicing.title' | translate }}</span>
          </div>
          
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'company' | translate }}</mat-label>
              <input matInput type="text" autocomplete="off" data-lpignore="true" data-form-type="other"
                formControlName="company"/>
            </mat-form-field>
            
            <mat-form-field appearance="outline">
              <mat-label>{{ 'name' | translate }}</mat-label>
              <input matInput type="text" autocomplete="off" data-lpignore="true" data-form-type="other"
                formControlName="name"/>
            </mat-form-field>
            
            <mat-form-field appearance="outline">
              <mat-label>{{ 'email' | translate }}</mat-label>
              <input matInput type="text" autocomplete="off" data-lpignore="true" data-form-type="other"
                formControlName="email"/>
            </mat-form-field>
            
            <mat-form-field appearance="outline">
              <mat-label>{{ 'phone' | translate }}</mat-label>
              <input matInput type="text" autocomplete="off" data-lpignore="true" data-form-type="other"
                formControlName="phone"/>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-span-full">
              <mat-label>{{ 'settings.transport.address.street1' | translate }}</mat-label>
              <input matInput type="text" autocomplete="off" data-lpignore="true" data-form-type="other"
                formControlName="street1"/>
            </mat-form-field>

            <mat-form-field appearance="outline" class="col-span-full">
              <mat-label>{{ 'settings.transport.address.street2' | translate }}</mat-label>
              <input matInput type="text" autocomplete="off" data-lpignore="true" data-form-type="other"
                formControlName="street2"/>
            </mat-form-field>
            
            <mat-form-field appearance="outline">
              <mat-label>{{ 'zip' | translate }}</mat-label>
              <input matInput type="text" autocomplete="off" data-lpignore="true" data-form-type="other"
                formControlName="zip"/>
            </mat-form-field>
            
            <mat-form-field appearance="outline">
              <mat-label>{{ 'city' | translate }}</mat-label>
              <input matInput type="text" autocomplete="off" data-lpignore="true" data-form-type="other"
                formControlName="city"/>
            </mat-form-field>
            
            <mat-form-field appearance="outline" class="col-span-full">
              <mat-label>{{ 'settings.transport.address.country' | translate }}</mat-label>
              <mat-select formControlName="country">
                @for (country of countryCodes; track country) {
                  <mat-option [value]="country.code">
                    {{ country.frenchName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    }
  </div>

  <div class="action-buttons">
    <button mat-raised-button color="primary"
      (click)="save()"
      [disabled]="orderForm?.invalid || (invoiceAddressForm && invoiceAddressForm.invalid) || progress">
      <mat-icon>save</mat-icon>
      {{ 'ADMIN.SAVE' | translate }}
    </button>
    <button mat-button (click)="endUpdate()">
      {{ 'common.cancel.edit' | translate }}
    </button>
  </div>
</div>
